import React, { useState, useEffect, useContext } from "react";
import {
  Button,
  Card,
  Form,
  Input,
  Select,
  Popconfirm,
  message,
  Modal,
  Spin,
  Space,
  Table,
  Typography
} from "antd";
import { PlusOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { request } from "../services/api";
import { AppContext } from "../context/AppContext";

const { Title, Text } = Typography;

const Questions = () => {
  const { levelOneOptions, levelTwoOptions, setLevelTwoOptions } =
    useContext(AppContext);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [nextOption, setNextOption] = useState(0);
  // eslint-disable-next-line
  const [optionLevelOne, setOptionLevelOne] = useState(0);
  const [optionLevelTwo, setOptionLevelTwo] = useState(null);
  //const [optionLevelThree, setOptionLevelThree] = useState(0);

  const [modalMode, setModalMode] = useState("create");
  const [currentRecord, setCurrentRecord] = useState(null);
  // eslint-disable-next-line
  const openCreateModal = () => {
    setModalMode("create");
    setCurrentRecord(null);
    form.resetFields();
    setIsModalOpen(true);
  };

  const openEditModal = (record) => {
    setModalMode("edit");
    setCurrentRecord(record);
    form.setFieldsValue(record);
    setIsModalOpen(true);
    console.log(record);
  };

  const onLevelOneChange = async (value) => {
    if (value > 0) {
      setOptionLevelTwo(null);
      setData([]);
    }
    await getLevelTwoOptions(value);
  };

  const getLevelTwoOptions = async (value) => {
    try {
      const params = `optionLevelOne=${value}`;
      setLoading(true);
      const response = await request(`/management/two/retrieve?${params}`, {
        method: "GET"
      });
      if (response.length > 0) {
        const cleanResponse = await cleanEmptyOptions(response);
        const menuOptionsLevelTwoValues = await renameKeyInArray(
          cleanResponse,
          "optionLevelTwo",
          "value"
        );
        const menuOptionsLevelTwoLabels = await renameKeyInArray(
          menuOptionsLevelTwoValues,
          "name",
          "label"
        );
        const safeOptions = menuOptionsLevelTwoLabels.map(
          ({ action, ...rest }) => ({
            ...rest,
            intentAction: action
          })
        );
        setLevelTwoOptions(safeOptions);
      }
    } catch (error) {
      message.error("No se pudo iniciar la consulta");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const cleanEmptyOptions = (item) => {
    const cleanedItem = item.filter((i) => i.action === "none");
    return cleanedItem;
  };

  const onLevelTwoChange = (value) => {
    if (value > 0) {
      start(value);
    }
    setOptionLevelTwo(value);
  };

  useEffect(() => {
    if (nextOption) {
      form.setFieldsValue({
        optionLevelThree: nextOption
      });
    }
  }, [isModalOpen, nextOption, form]);

  const renameKeyInArray = async (arr, oldKey, newKey) => {
    return arr.map((obj) => {
      const { [oldKey]: oldValue, ...rest } = obj;
      return {
        ...rest,
        [newKey]: oldValue
      };
    });
  };

  const start = async (value) => {
    try {
      if (value) {
        form.setFieldsValue({
          optionLevelOne: optionLevelOne,
          optionLevelTwo: value
        });
      }
      const params = `optionLevelOne=${optionLevelOne}&optionLevelTwo=${value}`;
      setLoading(true);
      const response = await request(
        `/management/questions/retrieve?${params}`,
        {
          method: "GET"
        }
      );
      const indexedData = response.map((item, index) => ({
        ...item,
        key: item.id || index
      }));
      if (indexedData.length === 0) {
        setNextOption(1);
      } else {
        setNextOption(
          indexedData[indexedData.length - 1]?.optionLevelThree + 1
        );
      }

      setData(indexedData);
    } catch (error) {
      message.error("No se pudo iniciar la consulta");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = async (values) => {
    try {
      setLoading(true);
      let datosAEnviar = { ...values };
      console.log(datosAEnviar);
      await request("/management/questions/create", {
        method: "POST",
        body: JSON.stringify(datosAEnviar)
      });
      message.success(`Registro creado`);
      setIsModalOpen(false);
      form.resetFields();
      start(optionLevelTwo);
    } catch (error) {
      message.error("Error al crear contacto");
      console.log("option cannot be added");
    } finally {
      setLoading(false);
      console.log("option added successfully");
    }
  };

  const removeAndResequence = (arr, removedValue) => {
    return arr
      .filter((item) => item.optionLevelTwo !== removedValue)
      .map((item) => {
        if (item.optionLevelTwo > removedValue) {
          return { ...item, optionLevelTwo: item.optionLevelTwo - 1 };
        }
        return item;
      });
  };

  const getItemsToUpdateAfterRemoval = (
    arr,
    removedValue,
    field = "optionLevelTwo"
  ) => {
    return arr
      .filter((item) => item?.[field] > removedValue)
      .map((item) => ({
        ...item,
        previousLevelTwo: item[field], // valor antes del ajuste
        [field]: item[field] - 1 // nuevo valor a guardar
      }));
  };

  const handleDelete = async (recordAEliminar) => {
    console.log("registro a eliminar", recordAEliminar);
    const { optionLevelTwo, optionLevelThree } = recordAEliminar;
    console.log("optionLevelTwo Item removed", optionLevelTwo);
    try {
      setLoading(true);
      await request(
        `/management/questions/remove?optionLevelTwo=${Number(optionLevelTwo)}&optionLevelThree=${Number(optionLevelThree)}`,
        {
          method: "DELETE"
        }
      );
      // eslint-disable-next-line
      const newData = removeAndResequence(data, optionLevelTwo);
      const dataToUpdate = getItemsToUpdateAfterRemoval(data, optionLevelTwo);
      if (dataToUpdate.length > 0) {
        await request("/management/two/sort", {
          method: "PATCH",
          body: JSON.stringify(dataToUpdate)
        });
      }
      start(optionLevelTwo);
    } catch (error) {
      message.error("No se pudo eliminar");
    } finally {
      setLoading(false);
      console.log("option removed successfully");
    }
  };

  const handleUpdate = async (recordAActualizar) => {
    try {
      delete recordAActualizar.key;
      setLoading(true);
      await request("/management/questions/update", {
        method: "PATCH",
        body: JSON.stringify(recordAActualizar)
      });
    } catch (error) {
      message.error("No se pudo actualizr");
    } finally {
      setLoading(false);
      console.log("option updated successfully");
      start(optionLevelTwo);
    }
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      if (modalMode === "create") {
        await handleCreate(values);
      } else {
        const { optionLevelThree, optionLevelTwo, key, ...newCurrentRecord } =
          values;
        const newValues = { ...currentRecord, ...newCurrentRecord };
        await handleUpdate(newValues);
      }
      setIsModalOpen(false);
      form.resetFields();
    } catch (err) {}
  };

  const columns = [
    {
      title: "Número",
      dataIndex: "optionLevelThree",
      key: "optionLevelThree",
      width: 100
    },
    { title: "Enunciado / Pregunta", dataIndex: "name", key: "name" },
    { title: "Acción", dataIndex: "action", key: "action", width: 200 },
    { title: "Guía", dataIndex: "guide", key: "guide", width: 250 },
    {
      title: "Actividades",
      key: "remover",
      fixed: "right",
      width: 110,
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="text"
            icon={<EditOutlined />}
            onClick={() => openEditModal(record)}
          />
          <Popconfirm
            title="Eliminar opción de menú"
            description={`¿Estás seguro de que deseas eliminar esta opción?, todas las dependencias serán eliminadas también`}
            onConfirm={() => handleDelete(record)}
            okText="Sí, eliminar"
            cancelText="No"
            okButtonProps={{ danger: true }}
          >
            <Button type="text" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      )
    }
  ];

  return (
    <div>
      <div style={{ marginBottom: 32 }}>
        <Title level={2} style={{ margin: 0 }}>
          Preguntas / Datos de Entrada
        </Title>
        <Text type="secondary">
          Alta y baja de los datos requeridos en cada interacción.
        </Text>
        <br />
        <Space style={{ marginTop: 16, marginBottom: 16 }}>
          <Select
            style={{ width: "200px" }}
            placeholder="Selecciona primer nivel"
            onChange={onLevelOneChange}
            options={levelOneOptions}
          />
          <Select
            style={{ width: "320px" }}
            placeholder="Selecciona segundo nivel"
            onChange={onLevelTwoChange}
            options={levelTwoOptions}
            value={optionLevelTwo}
          />
          {optionLevelTwo > 0 ? (
            <Button
              icon={<PlusOutlined />}
              onClick={() => setIsModalOpen(true)}
            >
              Nueva Opción
            </Button>
          ) : (
            <Button
              disabled
              icon={<PlusOutlined />}
              onClick={() => setIsModalOpen(true)}
            >
              Nueva Opción
            </Button>
          )}
        </Space>
        <Card>
          <Spin spinning={loading} description="Cargando información...">
            <Table
              dataSource={data}
              columns={columns}
              rowKey="key"
              pagination={false}
              tableLayout="fixed"
            />
          </Spin>
        </Card>
        <Modal
          title={modalMode === "create" ? "Nuevo registro" : "Editar registro"}
          open={isModalOpen}
          onCancel={() => {
            setIsModalOpen(false);
            form.resetFields();
          }}
          onOk={() => form.submit()}
          confirmLoading={loading}
          okText="Guardar"
          cancelText="Cancelar"
          okButtonProps={{ style: { background: "#000" } }}
          forceRender={true}
          destroyOnHidden
        >
          <Form form={form} layout="vertical" onFinish={handleSubmit}>
            <Form.Item
              name="optionLevelOne"
              label="Categoría principal"
              rules={[
                { required: true, message: "Ingresa la categoría principal" }
              ]}
            >
              <Input
                placeholder="ejemplo: 1,2"
                style={{ width: "70px" }}
                disabled
              />
            </Form.Item>
            <Form.Item
              name="optionLevelTwo"
              label="Subcategoría"
              rules={[
                { required: true, message: "Ingresa la categoría principal" }
              ]}
            >
              <Input
                placeholder="ejemplo: 3,4"
                style={{ width: "70px" }}
                disabled
              />
            </Form.Item>
            <Form.Item
              name="optionLevelThree"
              label="Número"
              rules={[
                { required: true, message: "Ingresa el número del elemento." }
              ]}
            >
              <Input
                placeholder="ejemplo: 5,6"
                style={{ width: "70px" }}
                disabled
              />
            </Form.Item>
            <Form.Item
              name="name"
              label="Enunciado / Pregunta"
              rules={[
                { required: true, message: "Ingresa el nombre de la opción" }
              ]}
            >
              <Input placeholder="ejemplo: Atención a clientes" />
            </Form.Item>
            <Form.Item
              name="guide"
              label="URL de la imágen a mostrar"
              rules={[{ required: false, message: "Ingresa la URL" }]}
            >
              <Input placeholder="ejemplo: www.imagenes.com/problemas/llamada-fallida.png" />
            </Form.Item>
            <Form.Item
              name="action"
              label="Acción"
              rules={[
                { required: true, message: "Ingresa la acción asignada" }
              ]}
            >
              <Select
                style={{ width: "200px" }}
                placeholder="Selecciona primer nivel"
                options={[
                  { label: "Ninguna", value: "none" },
                  { label: "Confirmar", value: "confirmation" },
                ]}
              />
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </div>
  );
};

export default Questions;
